import type {AddTraceEventEmitterProps, ClearTracesEventEmitterProps, TraceEventEmitterProps} from './type'

export const isAddTraceEventEmitterProps = (props: TraceEventEmitterProps): props is AddTraceEventEmitterProps => {
    return props.action === 'add'
}

export const isClearTracesEventEmitterProps = (
    props: TraceEventEmitterProps,
): props is ClearTracesEventEmitterProps => {
    return props.action === 'clear'
}
